import { FeatureList } from 'core/constants/common';
import Feature from './feature';

export default class SieraDashboards extends Feature {
  constructor(disabledFeatures: string[]) {
    super(FeatureList.sieraDashboards, disabledFeatures);
  }

  isAccessible(): boolean {
    return super.isRouteAccessible();
  }
}
